module.exports = __webpack_public_path__ + "img/portal-org.9ee2ac04.png";